import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Tvl from '../../../../shared/Tvl';
import PaginationSection from '../../../../shared/PaginationSection';
import TopUpRewardsModals from '../modals/TopUpRewardsModals';
import ExtendDurationModals from '../modals/ExtendDurationModals';
import WithdrawRewardsModals from '../modals/WithdrawRewardsModals';
import { useTheme } from '../../../../hooks/ThemeProvider';
import Loader from '../../../../shared/Loader';
import { toast } from 'react-toastify';

function RootPools({
    rootPools,
    currentPage,
    perPage,
    totalItems,
    onPageChange,
    onPerPageChange,
    fetchRootPools
}) {
    const [selectedPool, setSelectedPool] = useState(null);
    const [showTopUpModal, setShowTopUpModal] = useState(false);
    const [showExtendModal, setShowExtendModal] = useState(false);
    const [showWithdrawModal, setShowWithdrawModal] = useState(false);
    const { theme } = useTheme();

    // Helper function to check if pool is expired
    const isPoolExpired = (pool) => {
        const now = new Date();
        const expiry = pool?.duration ? new Date(pool.duration * 1000) : null;
        return expiry && expiry < now;
    };

    // Helper function to format date
    const formatDate = (timestamp) => {
        if (!timestamp) return { date: "End Date", time: "End Time" };
        const date = new Date(timestamp * 1000);
        return {
            date: date.toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "2-digit",
            }),
            time: date.toLocaleTimeString("en-US", {
                hour: "2-digit",
                minute: "2-digit",
            })
        };
    };

    const handleTopUpClick = (pool) => {
        setSelectedPool(pool);
        setShowTopUpModal(true);
    };

    const handleExtendClick = (pool) => {
        setSelectedPool(pool);
        setShowExtendModal(true);
    };

    const handleWithdrawClick = (pool) => {
        const currentTime = Math.floor(Date.now() / 1000); // current time in seconds

        if (pool.duration > currentTime) {
            toast.info("You can withdraw only after the pool duration ends!");
            return;
        }

        setSelectedPool(pool);
        setShowWithdrawModal(true);
    };

    return (
        <>
            <div
                className="tab-pane fade show active"
                id="pills-home"
                role="tabpanel"
                aria-labelledby="pills-home-tab"
            >
                {/* Desktop View */}
                <div className="table_main d-none d-lg-block">
                    <div className="table_innner">
                        <p className="one_sidee">#</p>
                        <p className="poolname">Pool Name</p>
                        <p>TVL</p>
                        <p>Rewards Funded</p>
                        {/* <p>Remaining Rewards</p> */}
                        <p>End Date/Time</p>
                        <p>Active Child Pools</p>
                        <p>Status</p>
                        <p></p>
                    </div>

                    {rootPools && rootPools.length > 0 ? (
                        rootPools.map((pool, index) => {
                            const isExpired = isPoolExpired(pool);
                            const { date, time } = formatDate(pool?.duration);

                            return (
                                <div className="table_innner" key={pool.id || index}>
                                    <h4 className="one_sidee">{index + 1}</h4>
                                    <div className="under_table LASTTTABLE">
                                        <img
                                            src={pool?.logo || "/assets/default.svg"}
                                            className="imgtable"
                                            alt="pool"
                                            height={20}
                                            width={20}
                                        />
                                        <div>
                                            <h6>{pool?.projectName || "Name"}</h6>
                                            <h5>{pool?.subName || "Sub Name"}</h5>
                                        </div>
                                    </div>

                                    <h4><Tvl contractAddress={pool?.contractAddress} poolType='rootPool' /></h4>
                                    <h4>{pool?.funded || 0}</h4>
                                    {/* <h4>{pool?.remaining || 0}</h4> */}

                                    <div className="under_table">
                                        <div>
                                            <h6>{date}</h6>
                                            <h5>{time}</h5>
                                        </div>
                                    </div>

                                    <h4>{pool?.activePools || 0}</h4>

                                    <div className={isExpired ? "expire" : "active"}>
                                        {isExpired ? "Expired" : "Active"}
                                    </div>

                                    <div className="drop_table">
                                        <Dropdown>
                                            <Dropdown.Toggle variant="success" id="dropdown-basic">
                                                {
                                                    theme === 'dark' ? <img src="/assets/threedots.svg" alt="options" />
                                                        : <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                            <path d="M6.99935 7.58332C7.32152 7.58332 7.58268 7.32216 7.58268 6.99999C7.58268 6.67782 7.32152 6.41666 6.99935 6.41666C6.67718 6.41666 6.41602 6.67782 6.41602 6.99999C6.41602 7.32216 6.67718 7.58332 6.99935 7.58332Z" stroke="#000F2F" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M6.99935 3.50001C7.32152 3.50001 7.58268 3.23884 7.58268 2.91668C7.58268 2.59451 7.32152 2.33334 6.99935 2.33334C6.67718 2.33334 6.41602 2.59451 6.41602 2.91668C6.41602 3.23884 6.67718 3.50001 6.99935 3.50001Z" stroke="#000F2F" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M6.99935 11.6667C7.32152 11.6667 7.58268 11.4055 7.58268 11.0833C7.58268 10.7612 7.32152 10.5 6.99935 10.5C6.67718 10.5 6.41602 10.7612 6.41602 11.0833C6.41602 11.4055 6.67718 11.6667 6.99935 11.6667Z" stroke="#000F2F" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                }
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <div className="innner_side">
                                                    <div className="inner_Drop">
                                                        <Link to={`/activepools/${pool?.contractAddress}`} className="inner_more">
                                                            <img src="/assets/view.svg" alt="view" />
                                                            <h5>View Pool</h5>
                                                        </Link>
                                                    </div>
                                                    {isExpired ? null :<>
                                                    <div className="inner_Drop">
                                                        <div className="inner_more" onClick={() => handleTopUpClick(pool)}>
                                                            <img src="/assets/top.svg" alt="top up" />
                                                            <h5>Top Up Rewards</h5>
                                                        </div>
                                                    </div>
                                                    <div className="inner_Drop">
                                                        <div className="inner_more" onClick={() => handleExtendClick(pool)}>
                                                            <img src="/assets/ex.svg" alt="extend" />
                                                            <h5>Extend Duration</h5>
                                                        </div>
                                                    </div>
                                                    </>  }
                                                    {parseInt(pool?.activePools) > 0 ? null : <div className="inner_Drop">
                                                        <div className="inner_more" onClick={() => handleWithdrawClick(pool)}>
                                                            <img src="\assets\with.svg" alt="withdraw" />
                                                            <h5>Withdraw Rewards</h5>
                                                        </div>
                                                    </div>}
                                                </div>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div className="no-data">
                            <p>No root pools found</p>
                        </div>
                    )}
                    <PaginationSection
                        currentPage={currentPage}
                        totalItems={totalItems}
                        perPage={perPage}
                        onPageChange={onPageChange}
                        onPerPageChange={onPerPageChange}
                    />
                </div>

                {/* Mobile View */}
                <div className="formobile d-block d-lg-none">
                    <div className="mobilebox">
                        {rootPools && rootPools.length > 0 ? (
                            rootPools.map((pool, index) => {
                                const isExpired = isPoolExpired(pool);
                                const { date, time } = formatDate(pool?.duration);

                                return (
                                    <div className="innerboxmain" key={pool.id || index}>
                                        <div className="parentinner">
                                            <div className="firstinnner">
                                                <h6>#</h6>
                                                <h5>{index + 1}</h5>
                                            </div>
                                            <div className="secondinnner">
                                                <h6>Pool Name</h6>
                                                <div className="parenttext">
                                                    <span>
                                                        <img
                                                            src={pool?.logo || "/assets/default.svg"}
                                                            className="imgtab"
                                                            alt="pool logo"
                                                            width={20}
                                                            height={20}
                                                        />
                                                    </span>
                                                    <div className="mainnnn">
                                                        <h5>{pool?.projectName || "Pool Name"}</h5>
                                                        <h6>{pool?.subName || "OASIS"}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="secondinnner">
                                                <h6>Status</h6>
                                                <h5 className={isExpired ? "red" : "green"}>
                                                    {isExpired ? "Expired" : "Active"}
                                                </h5>
                                            </div>
                                            <div className="thirdinnner">
                                                <div className="maindrop">
                                                    <Dropdown>
                                                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                                                            {
                                                                theme === 'dark' ? <img src="/assets/threedots.svg" alt="options" />
                                                                    : <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                        <path d="M6.99935 7.58332C7.32152 7.58332 7.58268 7.32216 7.58268 6.99999C7.58268 6.67782 7.32152 6.41666 6.99935 6.41666C6.67718 6.41666 6.41602 6.67782 6.41602 6.99999C6.41602 7.32216 6.67718 7.58332 6.99935 7.58332Z" stroke="#000F2F" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                                                        <path d="M6.99935 3.50001C7.32152 3.50001 7.58268 3.23884 7.58268 2.91668C7.58268 2.59451 7.32152 2.33334 6.99935 2.33334C6.67718 2.33334 6.41602 2.59451 6.41602 2.91668C6.41602 3.23884 6.67718 3.50001 6.99935 3.50001Z" stroke="#000F2F" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                                                        <path d="M6.99935 11.6667C7.32152 11.6667 7.58268 11.4055 7.58268 11.0833C7.58268 10.7612 7.32152 10.5 6.99935 10.5C6.67718 10.5 6.41602 10.7612 6.41602 11.0833C6.41602 11.4055 6.67718 11.6667 6.99935 11.6667Z" stroke="#000F2F" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                                                    </svg>
                                                            }
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Link to={`/activepools/${pool?.contractAddress}`} className="parent">
                                                                <img src="/assets/view.svg" alt="view" />
                                                                <h5>View Pool</h5>
                                                            </Link>
                                                            {isExpired ? <>
                                                            <div className="parent" onClick={() => handleTopUpClick(pool)}>
                                                                <img src="/assets/top.svg" alt="top up" />
                                                                <h5>Top Up Rewards</h5>
                                                            </div>
                                                            <div className="parent" onClick={() => handleExtendClick(pool)}>
                                                                <img src="/assets/ex.svg" alt="extend" />
                                                                <h5>Extend Duration</h5>
                                                            </div>
                                                            </> : null}
                                                            {parseInt(pool?.activePools) > 0 ? null :    <div className="parent" onClick={() => handleWithdrawClick(pool)}>
                                                                <img src="\assets\with.svg" alt="withdraw" />
                                                                <h5>Withdraw Rewards</h5>
                                                            </div>}
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mainbottom">
                                            <div className="innerbottomtex">
                                                <h6 className="live">TVL</h6>
                                                <h5 className="num"><Tvl contractAddress={pool?.contractAddress} poolType='rootPool' tokenAddress={pool?.rewardToken}/></h5>
                                            </div>
                                            <div className="innerbottomtex">
                                                <h6 className="live">Rewards Funded</h6>
                                                <h5 className="num">{pool?.funded || "0"}</h5>
                                            </div>
                                            {/* <div className="innerbottomtex">
                                                <h6 className="live">Remaining Rewards</h6>
                                                <h5 className="num">{pool?.remaining || "0"}</h5>
                                            </div> */}
                                            <div className="innerbottomtex">
                                                <h6 className="live">End Date/Time</h6>
                                                <h5 className="num">{date} {time}</h5>
                                            </div>
                                            {/* <div className="innerbottomtex">
                                                <h6 className="live">End Time</h6>
                                                <h5 className="num"></h5>
                                            </div> */}
                                            <div className="innerbottomtex">
                                                <h6 className="live">Active Child Pools</h6>
                                                <h5 className="num">{pool?.activePools || "0"}</h5>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="no-data">
                                <p>No root pools found</p>
                            </div>
                        )}

                        <PaginationSection
                            currentPage={currentPage}
                            totalItems={totalItems}
                            perPage={perPage}
                            onPageChange={onPageChange}
                            onPerPageChange={onPerPageChange}
                        />
                    </div>
                </div>
            </div>

            {/* Modals */}
            <TopUpRewardsModals
                show={showTopUpModal}
                onHide={() => setShowTopUpModal(false)}
                poolData={selectedPool}
                fetchRootPools={fetchRootPools}
            />

            <ExtendDurationModals
                show={showExtendModal}
                onHide={() => setShowExtendModal(false)}
                poolData={selectedPool}
                fetchRootPools={fetchRootPools}
            />

            <WithdrawRewardsModals
                show={showWithdrawModal}
                onHide={() => setShowWithdrawModal(false)}
                poolData={selectedPool}
                fetchRootPools={fetchRootPools}
            />
        </>
    );
}

export default RootPools;